<div class="flex flex-column gap-3 w-full" [formGroup]="intervalForm">
  <!-- Lower Bound -->
  <div class="flex gap-3">
    <span class="p-float-label">
      <p-inputNumber
        mode="decimal"
        id="lower-bound"
        formControlName="lowerBound"
        [class.ng-invalid]="intervalForm?.invalid"
        mode="decimal"
        minFractionDigits="0"
        [maxFractionDigits]="decimals === undefined ? 10 : decimals"
      >
      </p-inputNumber>
      <label for="lower-bound">Untere Grenze</label>
    </span>
    <p-checkbox formControlName="includeLowerBound" binary="true" label="Grenze einbeziehen"></p-checkbox>
  </div>

  <!-- Upper Bound  -->
  <div class="flex gap-3">
    <span class="p-float-label">
      <p-inputNumber
        mode="decimal"
        id="upper-bound"
        formControlName="upperBound"
        [class.ng-invalid]="intervalForm?.invalid"
        mode="decimal"
        minFractionDigits="0"
        [maxFractionDigits]="decimals === undefined ? 10 : decimals"
      >
      </p-inputNumber>
      <label for="upper-bound">Obere Grenze</label>
    </span>
    <p-checkbox formControlName="includeUpperBound" binary="true" label="Grenze einbeziehen"></p-checkbox>
  </div>
</div>
